<template>
  <div
    id="photo-slider"
    ref="sliderContainer"
  >
    <!-- Server-rendered slides via slot -->
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, nextTick } from 'vue'
import { tns } from 'tiny-slider/src/tiny-slider'
import GLightbox from 'glightbox'

const sliderContainer = ref<HTMLElement | null>(null)

onMounted(() => {
  nextTick(() => {
    const slideElements = sliderContainer.value?.querySelectorAll('.photo-slide')

    if (slideElements && slideElements.length > 0) {
      // Initialize tiny-slider
      tns({
        container: '#photo-slider',
        items: 1,
        slideBy: 1,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayButtonOutput: false,
        speed: 600,
        controls: true,
        controlsText: [
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 57 57"><path fill="#fff" d="M36.599 39.377 25.72 28.5 36.6 17.599l-3.35-3.349L19 28.5l14.25 14.25 3.349-3.373z"/></svg>',
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 57 57"><path fill="#fff" d="M20.401 39.377 31.28 28.5 20.4 17.599l3.349-3.349L38 28.5 23.75 42.75l-3.349-3.373z"/></svg>'
        ],
        nav: true,
        navPosition: 'bottom'
      })

      // Initialize GLightbox for all video links inside slides
      setTimeout(() => {
        GLightbox({
          selector: '.photo-slide .sidevideo a',
          autoplayVideos: true
        })
      }, 100)
    }
  })
})
</script>
